import {
  Box,
  Button,
  Chip,
  Container,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import LandingLayout, {
  useLanding,
} from "../../components/landing/LandingLayout";
import { useContext, useEffect, useRef, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import {
  GENERAL_DATA,
  RND,
  SECURED_BUSINESS_LOAN,
} from "shared/helpers/Constants";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowForward } from "@mui/icons-material";
import HeroText from "components/landing/HeroText";
import LandingCarousel from "components/landing/Carousel";
import AccordionFaqs from "components/landing/Accordion";
import MobileAppBar from "components/landing/MenuMobile";

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return isMobile;
};

export const handleScroll = (id: string, offset = 0) => {
  const element = document.getElementById(id);
  if (element) {
    const elementPosition =
      element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition + offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
};

const ApplyNowButton = () => {
  const { setEarlyAccess } = useLanding();
  const navigate = useNavigate();

  const showEarlyAccess = () => {
    setEarlyAccess(true);
  };

  return (
    <Button
      variant="contained"
      sx={{
        height: "32px",
        borderRadius: "8px",
        backgroundColor: "white",
        color: "#0053fd",
        fontSize: "15px",
        padding: "0 16px",
        textTransform: "none",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: "#f0f0f0",
          boxShadow: "none",
        },
      }}
      onClick={() => {
        navigate("/?sbl");
        return;
      }}
    >
      Apply now
      <Box
        component="img"
        src="/images/arrow-open.svg"
        sx={{ marginLeft: "0.5rem", width: "10px" }}
      />
    </Button>
  );
};

const ApplyNowButtonTransparent = () => {
  const { setEarlyAccess } = useLanding();

  const showEarlyAccess = () => {
    setEarlyAccess(true);
  };

  return (
    <Button
      variant="contained"
      sx={{
        height: "32px",
        borderRadius: "8px",
        backgroundColor: "transparent",
        color: "#0053fd",
        fontSize: "15px",
        fontWeight: "normal",
        boxShadow: "none",
        textTransform: "none",
        "&:hover": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
        padding: 0,
      }}
      onClick={() => showEarlyAccess()}
    >
      Apply now
      <ArrowForward sx={{ color: "#0053fd", marginLeft: "1rem" }} />
    </Button>
  );
};

const CalculateRepaymentButton = () => {
  const { setEarlyAccess } = useLanding();

  const showEarlyAccess = () => {
    setEarlyAccess(true);
  };

  return (
    <Button
      variant="contained"
      sx={{
        height: "32px",
        borderRadius: "8px",
        backgroundColor: "transparent",
        border: "1px solid #ffffff",
        color: "#ffffff",
        fontSize: "15px",
        padding: "0 16px",
        textTransform: "none",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: "#0053fd",
          boxShadow: "none",
        },
      }}
      // onClick={() => showEarlyAccess()}
    >
      Calculate repayments
    </Button>
  );
};

const LandingPage = () => {
  const carouselRef = useRef<any>(null);

  const [isVisible, setIsVisible] = useState(false);
  const [isSecondSectionVisible, setIsSecondSectionVisible] = useState(false);
  const [faqsTitle, setFaqsTitle] = useState("general");
  const [faqsData, setFaqsData] = useState(GENERAL_DATA);

  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const onVisibilityChange = (visible) => {
    setIsVisible(visible);
    // if (visible && !isVisible) {
    //   setIsVisible(true);
    // }
  };

  const onSecondSectionVisibilityChange = (visible) => {
    setIsSecondSectionVisible(visible);
  };

  const handleLearnMore = (number) => {
    handleScroll("faqs");
    if (number === 1) {
      setFaqsTitle("privatecredit");
      setFaqsData(SECURED_BUSINESS_LOAN);
      return;
    }
    setFaqsTitle("rnd");
    setFaqsData(RND);
  };

  useEffect(() => {
    const search = location.search;
    const params = new URLSearchParams(search);

    const sbl = params.get("sbl");
    const rnd = params.get("rnd");

    if (sbl !== null || search.includes("?sbl")) {
      handleScroll("ourproduct", 250);
      if (carouselRef.current) {
        carouselRef.current.goTo(0);
      }
    } else if (rnd !== null || search.includes("?rnd")) {
      handleScroll("ourproduct", 250);
      if (carouselRef.current) {
        carouselRef.current.goTo(1);
      }
    } else {
    }
  }, [location]);

  const isMobile = useIsMobile();

  return (
    <LandingLayout>
      <style>
        {`
        @keyframes handMove {
          0% {
            transform: translate(0, 0);
          }
          40% {
            transform: translate(0.26vw, -0.677vw);
          }
          60% {
            transform: translate(0.26vw, -0.677vw);
          }
          100% {
            transform: translate(0, 0);
          }
        }
        @keyframes blinkMove {
          0% {
            transform: translate(0, 0);
          }
          40% {
            transform: translate(-0.26vw, -0.677vw);
          }
          60% {
            transform: translate(-0.26vw, -0.677vw); 
          }
          100% {
            transform: translate(0, 0);
          }
        }
        @keyframes blinkSecondMove {
          0% {
            transform: translate(0, 0) scale(1);
          }
          40% {
            transform: translate(0.26vw, 1.198vw) scale(1.1); 
          }
          60% {
            transform: translate(0.26vw, 1.198vw) scale(1.1); 
          }
          100% {
            transform: translate(0, 0) scale(1);
          }
        }
        @keyframes paperMove {
          0% {
            transform: translate(0, 0) scale(1);
          }
          40% {
            transform: translate(-0.26vw, -0.677vw) scale(1.1);
          }
          60% {
            transform: translate(-0.26vw, -0.677vw) scale(1.1); 
          }
          100% {
            transform: translate(0, 0) scale(1);
          }
        }
        @keyframes warningMove {
          0% {
          transform: translate(0, 0) scale(1);
          }
          40% {
            transform: translate(0.26vw, 1.198vw) scale(1.1); 
          }
          60% {
            transform: translate(0.26vw, 1.198vw) scale(1.1); 
          }
          100% {
            transform: translate(0, 0) scale(1);
          }
        }
        @keyframes dollarMove {
          0% {
            transform: scale(1);
          }
          40% {
            transform: scale(1.2); 
          }
          60% {
            transform: scale(1.2);
          }
          100% {
            transform: scale(1); 
          }
        }
        @keyframes halfTextMove {
          0% {
            opacity: 1;
          }
          40% {
            opacity: 0;
          }
          60% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
        @keyframes fullTextMove {
          0% {
            opacity: 0;
          }
          40% {
            opacity: 1;
          }
          60% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
        `}
      </style>
      <Box sx={{ padding: "0 2.5vw", margin: "2.5vw 0" }}>
        <VisibilitySensor onChange={onVisibilityChange} partialVisibility>
          <Box
            sx={{
              height: "457px",
              backgroundColor: "#003AB1",
              borderRadius: "24px",
              display: "flex",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                padding: "60px",
                width: "100%",
                display: "block",
                [theme.breakpoints.down("md")]: {
                  display: "none",
                },
              }}
            >
              <Typography
                variant="h2"
                sx={{ fontSize: "72px", color: "white", lineHeight: 1.2 }}
                fontWeight={"600"}
              >
                Fast, Flexible
              </Typography>
              <HeroText
                texts={[
                  `Business${" "}Finance`,
                  `Secured${" "}Business${" "}Loan`,
                ]}
                speed={100}
                delayBetweenTexts={2000}
                fadeOutDuration={500}
              />

              <Box sx={{ marginTop: "1rem", color: "white" }}>
                <Typography
                  variant="body1"
                  sx={{ fontSize: "20px" }}
                  fontWeight={"normal"}
                  lineHeight={"30px"}
                >
                  Apply in minutes. Get a decision fast. Access funds as soon as
                  the next <br />
                  business day — with competitive rates and no hidden fees.
                </Typography>
              </Box>

              <Box sx={{ display: "flex", gap: "1rem", marginTop: "2rem" }}>
                <ApplyNowButton />
                {/* <CalculateRepaymentButton /> */}
              </Box>
            </Box>

            <img
              src="/images/hero-cover-img.png"
              style={{
                position: "absolute",
                right: "4rem",
                top: isVisible ? "-33rem" : "-2rem",
                width: "408px",
                zIndex: 2,
                transition: "top 1.5s ease-in-out",
              }}
            />

            <Box
              sx={{
                position: "absolute",
                right: "7%",
                top: isVisible ? "0.4rem" : "35rem",
                width: "411px",
                zIndex: 3,
                transition: "top 1s ease-in-out",
                transitionDelay: isVisible ? "0.5s" : "0s",
                [theme.breakpoints.down("md")]: {
                  right: 0,
                },
              }}
            >
              <img src="/images/girl-hero-2.svg" />
            </Box>

            <img
              src="/images/hero-banner-popup-1.png"
              style={{
                position: "absolute",
                right: "13%",
                top: isVisible ? "15rem" : "35rem",
                width: "285px",
                zIndex: 3,
                transition: "top 1s ease-in-out",
                transitionDelay: isVisible ? "1s" : "0s",
              }}
            />

            <img
              src="/images/hero-banner-popup-2.png"
              style={{
                position: "absolute",
                right: "3%",
                top: isVisible ? "20rem" : "35rem",
                width: "170px",
                zIndex: 3,
                transition: "top 1s ease-in-out",
                transitionDelay: isVisible ? "1.5s" : "0s",
              }}
            />

            <img
              src="/images/hero-banner-popup-3.png"
              style={{
                position: "absolute",
                right: "16%",
                top: isVisible ? "24rem" : "35rem",
                width: "243px",
                zIndex: 3,
                transition: "top 1s ease-in-out",
                transitionDelay: isVisible ? "1.5s" : "0s",
              }}
            />
          </Box>
        </VisibilitySensor>
      </Box>
      {/* Second Header */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 50,
          padding: "1.25vw 1.667vw",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #E5E5E5",
          border: "1px solid #E5E5E5",
          background: "white",
        }}
      >
        {/* Left Section */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            component="img"
            src="/images/ef-logo.svg"
            alt="EZIFIN Logo"
            sx={{
              marginRight: "2rem",
              [theme.breakpoints.down("md")]: {
                marginLeft: "1.5rem",
              },
            }}
          />
        </Box>

        {/* Right Section */}
        <Box
          sx={{
            display: "flex",
            gap: "2rem",
            alignItems: "center",
            [theme.breakpoints.down("md")]: {
              display: "none",
            },
          }}
        >
          <Typography
            sx={{ fontSize: "17px", cursor: "pointer" }}
            fontWeight={600}
            onClick={() => handleScroll("ourproduct")}
          >
            Our Products
          </Typography>
          <Typography
            sx={{ fontSize: "17px", cursor: "pointer" }}
            fontWeight={600}
            onClick={() => handleScroll("howitworks", -100)}
          >
            How it works
          </Typography>
          <Typography
            sx={{ fontSize: "17px", cursor: "pointer" }}
            fontWeight={600}
            onClick={() => handleScroll("featuresbenefits")}
          >
            Features
          </Typography>
          <Typography
            sx={{ fontSize: "17px", cursor: "pointer" }}
            fontWeight={600}
            onClick={() => handleScroll("whyus")}
          >
            Why
          </Typography>
          <Typography
            sx={{ fontSize: "17px", cursor: "pointer" }}
            fontWeight={600}
            onClick={() => handleScroll("faqs")}
          >
            FAQs
          </Typography>
        </Box>

        <Box
          sx={{
            display: "none",
            [theme.breakpoints.down("md")]: {
              display: "flex",
              marginRight: "0.5rem",
            },
            position: "relative",
          }}
        >
          <MobileAppBar section={"menu"} />
        </Box>
      </Box>
      {/* Main Content */}

      {/* our-product */}
      <Box
        sx={{ padding: "5.625vw 7.813vw", background: "#F8F8F6" }}
        id="ourproduct"
      >
        <Box sx={{ display: "flex" }}>
          <Box
            sx={{
              width: "85%",
              [theme.breakpoints.down("md")]: {
                width: "100%",
              },
            }}
          >
            <Typography fontSize={15} color="#848484" fontWeight={600}>
              OUR PRODUCTS
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: "48px",
                color: "#0A0A0A",
                lineHeight: 1.2,
                maxWidth: "78%",
                [theme.breakpoints.down("md")]: {
                  maxWidth: "100%",
                },
              }}
              //   fontSize: "clamp(45px, 4.21875vw - 9px, 72px)",
              fontWeight={"600"}
              mt={5}
            >
              Smart Finance Options to <br /> Power Your Growth
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "20px",
                width: "65%",
                marginTop: "1rem",
                color: "#474747",
                [theme.breakpoints.down("md")]: {
                  width: "100%",
                },
              }}
              fontWeight={"normal"}
              lineHeight={"30px"}
            >
              We make business finance clear, fast, and hassle-free so that{" "}
              <br /> you can focus on growth while we handle the details.
            </Typography>
          </Box>
          <Box
            sx={{
              width: "15%",
              [theme.breakpoints.down("md")]: {
                display: "none",
              },
            }}
          >
            <Box
              sx={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
            >
              <img
                src="/images/arrow-left-carousel.svg"
                style={{
                  padding: "20px 25px",
                  boxShadow: "0px 0px 8px 0px #0000001A",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => carouselRef.current.previous()}
              />
              <img
                src="/images/arrow-right-carousel.svg"
                style={{
                  padding: "20px 25px",
                  boxShadow: "0px 0px 8px 0px #0000001A",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => carouselRef.current.next()}
              />
            </Box>
          </Box>
        </Box>

        {/* Carousel */}
        <Box sx={{ marginTop: "2rem" }}>
          <LandingCarousel
            ref={carouselRef}
            handleLearnMore={handleLearnMore}
          />
        </Box>
      </Box>

      {/* how-it-works */}
      <Box
        id="howitworks"
        sx={{
          [theme.breakpoints.down("md")]: {
            marginBottom: "2rem",
          },
          [theme.breakpoints.up("xl")]: {
            marginBottom: "5.625vw",
          },
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            [theme.breakpoints.down("md")]: {
              padding: "0 1.875vw",
            },
          }}
        >
          <Typography
            fontSize={15}
            color="#848484"
            fontWeight={600}
            mt={"72px"}
          >
            HOW IT WORKS
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontSize: "48px",
              color: "#0A0A0A",
              lineHeight: 1.2,
            }}
            //   fontSize: "clamp(45px, 4.21875vw - 9px, 72px)",
            fontWeight={"600"}
            mt={5}
          >
            Simple Steps. Powerful Results.
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: "20px", marginTop: "1rem", color: "#474747" }}
            fontWeight={"normal"}
            lineHeight={"30px"}
          >
            We make business finance clear, fast, and hassle-free so that you
            can focus on <br />
            growth while we handle the details.
          </Typography>
        </Box>

        {/* Gridding */}
        {/* ----- 1 */}
        <Box sx={{ justifyItems: "center", display: "grid" }}>
          <Grid
            container
            spacing={2}
            mt={"70px"}
            sx={{ width: "51vw", height: "15rem" }}
          >
            <Box
              sx={{
                width: "24.5vw",
                height: "15rem",
                position: "absolute",
                marginLeft: "-2rem",
                borderLeft: "2px dashed #848484",
                borderBottom: "2px dashed #848484",
                borderBottomLeftRadius: "24px",
                background: "white",
                zIndex: 2,
              }}
            ></Box>
            <Grid
              size={{ xs: 11, md: 6 }}
              component="div"
              sx={{ textAlign: "left", position: "relative", zIndex: 3 }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  position: "relative",
                  left: "-2.7rem",
                }}
              >
                <Box>
                  <Box
                    sx={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      background: "#F2F6FF",
                      color: "#0053FD",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      top: "-5px",
                      left: "-2px",
                    }}
                  >
                    #1
                  </Box>
                </Box>

                <Typography
                  variant="body1"
                  sx={{ fontSize: "20px", color: "#0A0A0A" }}
                  fontWeight={"600"}
                >
                  Submit Your Request
                </Typography>
              </Box>

              <Typography
                variant="body1"
                sx={{ fontSize: "16px", color: "#474747", marginTop: "1rem" }}
              >
                Businesses or advisers provide basic <br />
                information about the funding needs — whether <br />
                it’s secured business loan, R&D finance, or a combination <br />{" "}
                of both.
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 1, md: 6 }}
              component="div"
              sx={{ textAlign: "center", position: "relative", zIndex: 3 }}
            >
              <Box
                sx={{
                  display: "flex",
                  position: "relative",
                  [theme.breakpoints.up("lg")]: {
                    left: "4.5vw",
                  },
                }}
              >
                <img
                  src="/images/laptop.svg"
                  className="gridding-image"
                  style={{
                    position: "relative",
                    width: "14.063vw",
                    left: "2vw",
                  }}
                />
                <img
                  src="/images/laptop-line.svg"
                  className="gridding-image"
                  style={{
                    position: "absolute",
                    left: 0,
                    marginLeft: "4.7vw",
                    marginTop: "2vw",
                    width: "8.698vw",
                  }}
                />
                <img
                  src="/images/laptop-line.svg"
                  className="gridding-image"
                  style={{
                    position: "absolute",
                    left: 0,
                    marginLeft: "4.7vw",
                    marginTop: "4vw",
                    width: "8.698vw",
                  }}
                />
                <img
                  src="/images/laptop-hand.svg"
                  style={{
                    position: "absolute",
                    left: 0,
                    marginLeft: "0.3vw",
                    marginTop: "4vw",
                    width: "6.698vw",
                    animation: "handMove 2s ease-in-out infinite alternate",
                  }}
                />
                <img
                  src="/images/laptop-blink.svg"
                  className="gridding-image"
                  style={{
                    position: "absolute",
                    left: 0,
                    marginLeft: "10.7vw",
                    marginTop: "4vw",
                    width: "1.51vw",
                    animation: "blinkMove 2s ease-in-out infinite alternate",
                  }}
                />
                <img
                  src="/images/laptop-blink.svg"
                  className="gridding-image"
                  style={{
                    position: "absolute",
                    left: 0,
                    marginLeft: "11.7vw",
                    marginTop: "9vw",
                    width: "2.083vw",
                    animation:
                      "blinkSecondMove 2s ease-in-out infinite alternate",
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* ----- 2 */}
        <Box sx={{ justifyItems: "center", display: "grid" }}>
          <Grid
            container
            spacing={2}
            mt={"70px"}
            sx={{ width: "51vw", height: "15rem" }}
          >
            <Box
              sx={{
                width: "24.5vw",
                height: "18rem",
                position: "absolute",
                marginLeft: "-0.5rem",
                borderRight: "2px dashed #848484",
                borderBottom: "2px dashed #848484",
                borderBottomRightRadius: "24px",
                marginTop: "-4.41rem",
                borderTop: "2px dashed #848484",
                borderTopRightRadius: "24px",
              }}
            ></Box>
            <Grid
              size={{ xs: 1, md: 6 }}
              component="div"
              sx={{ textAlign: "left" }}
            >
              <Box
                sx={{
                  display: "flex",
                  position: "relative",
                  [theme.breakpoints.up("lg")]: {},
                }}
              >
                <img
                  src="/images/shield-circle.svg"
                  style={{
                    position: "relative",
                    top: "-2.3vw",
                    width: "12.567vw",
                  }}
                />
                <img
                  src="/images/shield-shield.svg"
                  style={{
                    position: "absolute",
                    width: "10.044vw",
                    left: 0,
                    marginLeft: "1.2vw",
                    top: "-0.5vw",
                  }}
                />
                <img
                  src="/images/shield-paper.svg"
                  style={{
                    position: "absolute",
                    left: 0,
                    marginLeft: "7vw",
                    top: "3.6vw",
                    width: "3.565vw",
                    animation: "paperMove 2s ease-in-out infinite alternate",
                  }}
                />
                <img
                  src="/images/shield-warning.svg"
                  style={{
                    position: "absolute",
                    left: 0,
                    marginLeft: "3.7vw",
                    top: "-1.3vw",
                    width: "1.5vw",
                    animation: "warningMove 2s ease-in-out infinite alternate",
                  }}
                />
              </Box>
            </Grid>
            <Grid
              size={{ xs: 11, md: 6 }}
              component="div"
              sx={{
                textAlign: "left",
                [theme.breakpoints.down("md")]: {
                  position: "relative",
                  left: "22vw",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  position: "relative",
                  left: "calc(-5% + -1.2rem)",
                }}
              >
                <Box>
                  <Box
                    sx={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      background: "#F2F6FF",
                      color: "#0053FD",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      top: "-5px",
                      left: "-2px",
                    }}
                  >
                    #2
                  </Box>
                </Box>
                <Typography
                  variant="body1"
                  sx={{ fontSize: "20px", color: "#0A0A0A" }}
                  fontWeight={"600"}
                >
                  Assessment & Structuring
                </Typography>
              </Box>

              <Typography
                variant="body1"
                sx={{
                  fontSize: "16px",
                  color: "#474747",
                  marginTop: "1rem",
                  marginLeft: "0.7rem",
                }}
              >
                EZIFIN reviews the request, R&D eligibility, and available
                security, then designs a funding solution accordingly to match
                your objectives and/or adviser requirements.
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {/* ----- 3 */}
        <Box sx={{ justifyItems: "center", display: "grid" }}>
          <Grid
            container
            spacing={2}
            mt={"70px"}
            sx={{ width: "51vw", height: "15rem" }}
          >
            <Box
              sx={{
                width: "24.5vw",
                height: "15rem",
                position: "absolute",
                marginLeft: "-2rem",
                borderLeft: "2px dashed #848484",
                borderTop: "2px dashed #848484",
                borderTopLeftRadius: "24px",
                background: "white",
                zIndex: 2,
                marginTop: "-5.63rem",
              }}
            ></Box>
            <Box
              sx={{
                width: "24.5vw",
                height: "15rem",
                position: "absolute",
                marginLeft: "-2rem",
                borderLeft: "2px dashed #848484",
                borderBottom: "2px dashed #848484",
                borderBottomLeftRadius: "24px",
                background: "white",
                zIndex: 2,
              }}
            ></Box>
            <Grid
              size={{ xs: 10, md: 6 }}
              component="div"
              sx={{ textAlign: "left", position: "relative", zIndex: 3 }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  position: "relative",
                  left: "-2.7rem",
                }}
              >
                <Box>
                  <Box
                    sx={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      background: "#F2F6FF",
                      color: "#0053FD",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      top: "-5px",
                      left: "-2px",
                    }}
                  >
                    #3
                  </Box>
                </Box>
                <Typography
                  variant="body1"
                  sx={{ fontSize: "20px", color: "#0A0A0A" }}
                  fontWeight={"600"}
                >
                  Approval & Documentation
                </Typography>
              </Box>

              <Typography
                variant="body1"
                sx={{ fontSize: "16px", color: "#474747", marginTop: "1rem" }}
              >
                Once the structure is agreed, EZIFIN provides clear
                documentation and approvals, simplifying the process so advisers
                and businesses can move quickly.
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 2, md: 6 }}
              component="div"
              sx={{ textAlign: "center", position: "relative", zIndex: 3 }}
            >
              <Box
                sx={{
                  display: "flex",
                  position: "relative",
                  [theme.breakpoints.up("lg")]: {
                    left: "4.5vw",
                  },
                }}
              >
                <img
                  src="/images/how-it-works-approval.svg"
                  style={{
                    width: "13.346vw",
                    position: "relative",
                    top: "-3vw",
                    left: "2vw",
                  }}
                />
                <img
                  src="/images/approval-circle.svg"
                  style={{
                    width: "3.5vw",
                    position: "absolute",
                    left: 0,
                    marginLeft: "11.6vw",
                    top: "1.8vw",
                  }}
                />
                <img
                  src="/images/approval-dollar.svg"
                  style={{
                    width: "2.421vw",
                    position: "absolute",
                    left: 0,
                    marginLeft: "12vw",
                    top: "1.8vw",
                    animation: "dollarMove 2s ease-in-out infinite alternate",
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* ----- 4 */}
        <Box sx={{ justifyItems: "center", display: "grid" }}>
          <Grid
            container
            spacing={2}
            mt={"70px"}
            sx={{ width: "51vw", height: "15rem" }}
          >
            <Box
              sx={{
                width: "24.5vw",
                height: "5rem",
                position: "absolute",
                marginLeft: "-0.5rem",
                borderRight: "2px dashed #848484",
                marginTop: "-4.41rem",
                borderTop: "2px dashed #848484",
                borderTopRightRadius: "24px",
              }}
            ></Box>
            <Grid
              size={{ xs: 1, md: 6 }}
              component="div"
              sx={{ textAlign: "left" }}
            >
              <Box
                sx={{
                  display: "flex",
                  position: "relative",
                  [theme.breakpoints.up("lg")]: {},
                }}
              >
                <img
                  src="/images/how-it-works-support.svg"
                  style={{
                    position: "relative",
                    width: "13.346vw",
                    top: "-2vw",
                  }}
                />
                <img
                  src="/images/funding-paper.svg"
                  style={{
                    position: "absolute",
                    width: "6.346vw",
                    left: 0,
                    marginLeft: "2.8vw",
                    top: "-1.5vw",
                    height: "6.4vw",
                  }}
                />
                <img
                  src="/images/funding-half-text.svg"
                  style={{
                    position: "absolute",
                    width: "3.169vw",
                    left: 0,
                    marginLeft: "3.8vw",
                    top: "1.5vw",
                    animation: "halfTextMove 2s ease-in-out infinite alternate",
                  }}
                />
                <img
                  src="/images/funding-full-text.svg"
                  style={{
                    position: "absolute",
                    width: "5.741vw",
                    left: 0,
                    marginLeft: "3.8vw",
                    top: "1.5vw",
                    animation: "fullTextMove 2s ease-in-out infinite alternate",
                  }}
                />
                <img
                  src="/images/funding-dollar.svg"
                  style={{
                    position: "absolute",
                    width: "1.67vw",
                    left: 0,
                    marginLeft: "5.8vw",
                    top: "-1.5vw",
                    animation: "dollarMove 2s ease-in-out infinite alternate",
                  }}
                />
              </Box>
            </Grid>
            <Grid
              size={{ xs: 11, md: 6 }}
              component="div"
              sx={{
                textAlign: "left",
                [theme.breakpoints.down("md")]: {
                  position: "relative",
                  left: "22vw",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  position: "relative",
                  left: "calc(-5% + -1.2rem)",
                }}
              >
                <Box>
                  <Box
                    sx={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      background: "#F2F6FF",
                      color: "#0053FD",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      top: "-5px",
                      left: "-2px",
                    }}
                  >
                    #4
                  </Box>
                </Box>
                <Typography
                  variant="body1"
                  sx={{ fontSize: "20px", color: "#0A0A0A" }}
                  fontWeight={"600"}
                >
                  Funding & Ongoing Support
                </Typography>
              </Box>

              <Typography
                variant="body1"
                sx={{
                  fontSize: "16px",
                  color: "#474747",
                  marginTop: "1rem",
                  marginLeft: "0.7rem",
                }}
              >
                Funds are released. EZIFIN continues to provide, monitoring, and
                support throughout the life of the facility, ensuring
                flexibility and transparency.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* features-&-benefits */}
      <Box
        id="featuresbenefits"
        className="hero-features"
        sx={{
          padding: "5.469vw 7.813vw",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            [theme.breakpoints.down("md")]: {
              marginTop: "2rem",
            },
          }}
        >
          <Typography fontSize={15} color="#848484" fontWeight={600}>
            Features & benefits
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontSize: "48px",
              color: "#0A0A0A",
              lineHeight: 1.2,
            }}
            //   fontSize: "clamp(45px, 4.21875vw - 9px, 72px)",
            fontWeight={"600"}
            mt={5}
          >
            Finance Without the Friction
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: "20px", marginTop: "1rem", color: "#474747" }}
            fontWeight={"normal"}
            lineHeight={"30px"}
          >
            Experience lending built around you which is quick, transparent, and
            flexible. We <br />
            make borrowing easier so you can stay focused on growing what
            matters to you.
          </Typography>
        </Box>

        {/* Gridding */}
        <Grid container spacing={4} mt={"2rem"}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                padding: "8px",
                borderRadius: "24px",
                border: "1px solid #E5E5E5",
                background: "white",
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  padding: "8px",
                  borderRadius: "24px",
                  border: "1px solid #E5E5E5",
                }}
              >
                <Box sx={{ padding: "24px" }}>
                  <img
                    src="/images/fast-approval.svg"
                    style={{ width: "100%", height: isMobile ? "" : "280px" }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "20px",
                      color: "#0A0A0A",
                      textAlign: "left",
                    }}
                    fontWeight={"600"}
                  >
                    Fast Approvals
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "16px",
                      color: "#474747",
                      marginTop: "1rem",
                      textAlign: "left",
                      minHeight: "2.6rem",
                    }}
                  >
                    Quick, hassle-free approval process – get funded within
                    days, not weeks.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                padding: "8px",
                borderRadius: "24px",
                border: "1px solid #E5E5E5",
                background: "white",
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  padding: "8px",
                  borderRadius: "24px",
                  border: "1px solid #E5E5E5",
                }}
              >
                <Box sx={{ padding: "24px" }}>
                  <img
                    src="/images/personalised-service.svg"
                    style={{ width: "100%", height: isMobile ? "" : "280px" }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "20px",
                      color: "#0A0A0A",
                      textAlign: "left",
                    }}
                    fontWeight={"600"}
                  >
                    Personalised Service
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "16px",
                      color: "#474747",
                      marginTop: "1rem",
                      textAlign: "left",
                      minHeight: "2.6rem",
                    }}
                  >
                    A dedicated loan officer to guide you through the entire
                    process.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Grid container spacing={4} sx={{ marginTop: "16px" }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                padding: "8px",
                borderRadius: "24px",
                border: "1px solid #E5E5E5",
                background: "white",
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  padding: "8px",
                  borderRadius: "24px",
                  border: "1px solid #E5E5E5",
                }}
              >
                <Box sx={{ padding: "24px" }}>
                  <img
                    src="/images/no-credit-history.svg"
                    style={{ width: "100%", height: isMobile ? "" : "280px" }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "20px",
                      color: "#0A0A0A",
                      textAlign: "left",
                    }}
                    fontWeight={"600"}
                  >
                    No Credit History Required
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "16px",
                      color: "#474747",
                      marginTop: "1rem",
                      textAlign: "left",
                      minHeight: "2.6rem",
                    }}
                  >
                    We focus on the value of your property, not just your credit
                    score.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                padding: "8px",
                borderRadius: "24px",
                border: "1px solid #E5E5E5",
                background: "white",
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  padding: "8px",
                  borderRadius: "24px",
                  border: "1px solid #E5E5E5",
                }}
              >
                <Box sx={{ padding: "24px" }}>
                  <img
                    src="/images/flexibility.svg"
                    style={{ width: "100%", height: isMobile ? "" : "280px" }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "20px",
                      color: "#0A0A0A",
                      textAlign: "left",
                    }}
                    fontWeight={"600"}
                  >
                    Flexibility
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "16px",
                      color: "#474747",
                      marginTop: "1rem",
                      textAlign: "left",
                      minHeight: "2.6rem",
                    }}
                  >
                    We tailor loan terms to suit your specific needs and
                    circumstances
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* why-us */}
      <Box
        id="whyus"
        sx={{ padding: "5.469vw 7.813vw", borderBottom: "1px solid #F3F3F5" }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Typography fontSize={15} color="#848484" fontWeight={600}>
            WHY US
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontSize: "48px",
              color: "#0A0A0A",
              lineHeight: 1.2,
            }}
            //   fontSize: "clamp(45px, 4.21875vw - 9px, 72px)",
            fontWeight={"600"}
            mt={5}
          >
            Get funding that works.
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: "20px", marginTop: "1rem", color: "#474747" }}
            fontWeight={"normal"}
            lineHeight={"30px"}
          >
            From secured business loan to R&D finance, EZIFIN cuts the
            complexity with fast approvals, <br /> flexible structures, and
            funding designed around your business.
          </Typography>
        </Box>

        <Box>
          <Grid container spacing={4} mt={"2rem"}>
            <Grid size={{ xs: 12, md: 4 }}>
              <Box
                sx={{
                  padding: "32px",
                  background: "#775CCF26",
                  borderRadius: "16px",
                  minHeight: "28rem",
                }}
              >
                <img src="/images/time-is-money.gif" width={64} />
                <Typography
                  fontSize={22}
                  fontWeight={"600"}
                  mt={"1rem"}
                  lineHeight={"normal"}
                  minHeight={"3.5rem"}
                >
                  Fast, Flexible, and Hassle-Free
                </Typography>
                <Typography fontSize={17} fontWeight={"normal"} mt={"1rem"}>
                  EZIFIN was built to cut through the red tape of traditional
                  banks. With streamlined applications, rapid approvals, and
                  tailored loan options, borrowers can access funds
                  quickly—whether it’s for business needs, business ventures or
                  property development. We make finance simple, secure, and
                  designed around your goals, not bureaucracy.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Box
                sx={{
                  padding: "32px",
                  background: "#5FD08F26",
                  borderRadius: "16px",
                  minHeight: "28rem",
                }}
              >
                <img src="/images/tailored-trusted.gif" width={64} />
                <Typography
                  fontSize={22}
                  fontWeight={"600"}
                  mt={"1rem"}
                  lineHeight={"normal"}
                  minHeight={"3.5rem"}
                >
                  Tailored, Transparent, Trusted 
                </Typography>
                <Typography fontSize={17} fontWeight={"normal"} mt={"1rem"}>
                  Big institutions and niche players often push
                  one-size-fits-all products. EZIFIN differentiates by
                  partnering closely with borrowers, tailoring facilities to
                  cashflow and security, and being transparent about returns,
                  fees and exits — building trust and long-term relationships.
                  Our win-win philosophy means your success is ours. 
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Box
                sx={{
                  padding: "32px",
                  background: "#FE994E26",
                  borderRadius: "16px",
                  minHeight: "28rem",
                }}
              >
                <img src="/images/money-bag.gif" width={64} />
                <Typography
                  fontSize={22}
                  fontWeight={"600"}
                  mt={"1rem"}
                  lineHeight={"normal"}
                  minHeight={"3.5rem"}
                >
                  The Adviser’s Dilemma 
                </Typography>
                <Typography fontSize={17} fontWeight={"normal"} mt={"1rem"}>
                  For advisers, managing one client’s needs across multiple
                  lenders can be a headache — an R&D advance from one, working
                  capital and property-backed security from another, can slow
                  down your application and release of funds. EZIFIN removes the
                  friction with a platform that brings secured business loans
                  and R&D finance solutions together in one place, with
                  streamlined documentation, clear reporting, and a single
                  trusted relationship. 
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* next-business */}
      <Box padding={"17.969vw 7.813vw 2.344vw 7.813vw"}>
        <VisibilitySensor
          onChange={onSecondSectionVisibilityChange}
          partialVisibility
        >
          <Box>
            <Box sx={{ display: "flex" }}>
              <img
                src="/images/coin-icon.svg"
                style={{
                  position: "absolute",
                  left: isSecondSectionVisible
                    ? isMobile
                      ? "-11vw"
                      : "7vw"
                    : "27vw",
                  zIndex: 5,
                  transition: "left 1s ease-in-out, margin-top 1s ease-in-out",
                  marginTop: isSecondSectionVisible
                    ? isMobile
                      ? "-33vw"
                      : "-9vw"
                    : 0,
                }}
              />
              <img
                src="/images/submit-icon.svg"
                style={{
                  position: "absolute",
                  left: isMobile ? "35vw" : "45vw",
                  zIndex: 4,
                  transition: "top 1s ease-in-out, margin-top 1s ease-in-out",
                  marginTop: isSecondSectionVisible
                    ? isMobile
                      ? "-32vw"
                      : "-13vw"
                    : 0,
                }}
              />
              <img
                src="/images/person-business.svg"
                style={{
                  position: "absolute",
                  left: isSecondSectionVisible
                    ? isMobile
                      ? "1vw"
                      : "20vw"
                    : "49vw",
                  zIndex: 3,
                  transition: "left 1s ease-in-out, margin-top 1s ease-in-out",
                  marginTop: isSecondSectionVisible
                    ? isMobile
                      ? "88vw"
                      : "12vw"
                    : 0,
                }}
              />
              <img
                src="/images/calculator.svg"
                style={{
                  position: "absolute",
                  left: isSecondSectionVisible ? "67vw" : "56vw",
                  zIndex: 2,
                  transition: "left 1s ease-in-out, margin-top 1s ease-in-out",
                  marginTop: isSecondSectionVisible
                    ? isMobile
                      ? "47vw"
                      : "13vw"
                    : 0,
                }}
              />
              <img
                src="/images/person-applying.svg"
                style={{
                  position: "absolute",
                  left: isSecondSectionVisible
                    ? isMobile
                      ? "79vw"
                      : "78vw"
                    : "67vw",
                  zIndex: 1,
                  transition: "left 1s ease-in-out, margin-top 1s ease-in-out",
                  marginTop: isSecondSectionVisible
                    ? isMobile
                      ? "-27vw"
                      : "-10vw"
                    : 0,
                }}
              />
            </Box>

            <Typography
              fontSize={"72px"}
              lineHeight={"normal"}
              sx={{
                textAlign: "center",
                fontWeight: 600,
              }}
            >
              Your next business <br /> loan awaits
            </Typography>

            <Box
              sx={{
                position: "relative",
                left: isSecondSectionVisible ? 0 : "-50%",
                transition: "left 1.5s ease-in-out",
              }}
            >
              <Typography
                fontSize={28}
                fontWeight={"600"}
                mt={"230px"}
                lineHeight={"normal"}
              >
                Fuel Your Business Growth
              </Typography>
              <Typography fontSize={17} fontWeight={"normal"} mt={"1rem"}>
                Fast, flexible funding made simple. Apply online for <br />{" "}
                Business Loans or R&D Finance.
              </Typography>
              <ApplyNowButtonTransparent />
            </Box>
          </Box>
        </VisibilitySensor>
      </Box>

      {/* FAQ's */}
      <Box id="faqs" sx={{ padding: "5.625vw 7.813vw", background: "#F8F8F6" }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: "48px",
              color: "#0A0A0A",
              lineHeight: 1.2,
            }}
            //   fontSize: "clamp(45px, 4.21875vw - 9px, 72px)",
            fontWeight={"600"}
            mt={5}
          >
            Frequently asked questions
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "1rem",
            flexWrap: "wrap",
            marginTop: "2rem",
          }}
        >
          <Chip
            label="General"
            sx={{
              fontSize: "20px",
              color: "#0A0A0A",
              cursor: "pointer",
              background: faqsTitle === "general" ? "white" : "transparent",
              border: faqsTitle === "general" ? "1px solid #E5E5E5" : "",
            }}
            onClick={() => {
              setFaqsData(GENERAL_DATA);
              setFaqsTitle("general");
            }}
          />
          <Chip
            label="Secured Business Loan"
            sx={{
              fontSize: "20px",
              color: "#0A0A0A",
              cursor: "pointer",
              background:
                faqsTitle === "privatecredit" ? "white" : "transparent",
              border: faqsTitle === "privatecredit" ? "1px solid #E5E5E5" : "",
            }}
            onClick={() => {
              setFaqsData(SECURED_BUSINESS_LOAN);
              setFaqsTitle("privatecredit");
            }}
          />
          <Chip
            label="R&D Finance"
            sx={{
              fontSize: "20px",
              color: "#0A0A0A",
              cursor: "pointer",
              background: faqsTitle === "rnd" ? "white" : "transparent",
              border: faqsTitle === "rnd" ? "1px solid #E5E5E5" : "",
            }}
            onClick={() => {
              setFaqsData(RND);
              setFaqsTitle("rnd");
            }}
          />
        </Box>

        <Box mt={"2rem"}>
          <AccordionFaqs faqsData={faqsData} />
        </Box>
      </Box>

      {/* Next Step */}
      <Box sx={{ padding: "5.625vw 7.813vw", background: "white" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            [theme.breakpoints.down("md")]: {
              gap: "2rem",
            },
          }}
        >
          <Box
            sx={{
              width: "65%",
              [theme.breakpoints.down("md")]: {
                width: "100%",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: "48px",
                color: "#0A0A0A",
                lineHeight: 1.2,
              }}
              //   fontSize: "clamp(45px, 4.21875vw - 9px, 72px)",
              fontWeight={"600"}
              mt={5}
            >
              Ready to take the next step
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "20px",
                marginTop: "1rem",
                color: "#0A0A0A",
              }}
              fontWeight={"normal"}
              lineHeight={"30px"}
            >
              Let EZIFIN match you with the right loan — faster, smarter and
              with
              <br /> zero guesswork. Our experienced team is here to help you
              grow.
            </Typography>
          </Box>
          <Box
            sx={{
              width: "35%",
              textAlign: "center",
              alignContent: "center",
              [theme.breakpoints.down("md")]: {
                width: "100%",
              },
            }}
          >
            <Box sx={{ display: "grid", gap: "1rem", alignContent: "center" }}>
              <Button
                variant="contained"
                sx={{
                  borderRadius: "8px",
                  backgroundColor: "#0053FD",
                  color: "white",
                  fontSize: "15px",
                  padding: "0 16px",
                  textTransform: "none",
                  boxShadow: "none",
                }}
                style={{
                  height: "56px",
                }}
                onClick={() => navigate("/contact-us")}
              >
                Get started
              </Button>
              <Button
                variant="contained"
                sx={{
                  borderRadius: "8px",
                  backgroundColor: "white",
                  color: "#0A0A0A",
                  fontSize: "15px",
                  padding: "0 16px",
                  textTransform: "none",
                  boxShadow: "none",
                  border: "1px solid #E5E5E5",
                }}
                style={{
                  height: "56px",
                }}
                onClick={() =>
                  window.open(
                    "https://outlook.office.com/book/EzifinBookaDemo@lakeba.com/s/u3L03N3vbU6KiVSEZEB5sw2?ismsaljsauthenabled=true",
                    "_blank",
                  )
                }
              >
                Book a demo
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </LandingLayout>
  );
};

export default LandingPage;
